import(/* webpackMode: "eager" */ "/vercel/path0/app/[[...slug]]/page.js");
